import { formatCurrency } from '@if/core/utils'
import { DocumentField, Placeholder, SummaryCard } from '@if/mui'
import { LoanSummaryInformationResultDto } from '@src/api/loan/loan-dto'
import { Coins } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  summaryInformation: LoanSummaryInformationResultDto
}

const LoanLastTransactionCard = ({ summaryInformation }: Props) => {
  const { t } = useTranslation()

  if (summaryInformation === undefined) {
    return (
      <SummaryCard icon={Coins} title={t('loan.payment.lastTransactionCard.title')} dense>
        <Placeholder>{t('loan.payment.lastTransactionCard.empty')}</Placeholder>
      </SummaryCard>
    )
  }

  const totalPrincipalPaid = summaryInformation.totalPrincipalPaid ?? 0
  const totalInterestPaid = summaryInformation.totalInterestPaid ?? 0
  const totalFeesPaid = (summaryInformation.totalAdminFeesPaid ?? 0) + (summaryInformation.totalNsfFeesPaid ?? 0)

  return (
    <SummaryCard icon={Coins} title={t('loan.payment.lastTransactionCard.title')} dense>
      <DocumentField
        label={t('loan.payment.lastTransactionCard.totalPrincipal')}
        align="right"
        value={formatCurrency(totalPrincipalPaid)}
      />
      <DocumentField
        label={t('loan.payment.lastTransactionCard.totalInterest')}
        align="right"
        value={formatCurrency(totalInterestPaid)}
      />
      <DocumentField
        label={t('loan.payment.lastTransactionCard.totalFees')}
        align="right"
        value={formatCurrency(totalFeesPaid)}
      />
      <DocumentField
        label={t('loan.payment.lastTransactionCard.totalPaid')}
        align="right"
        value={formatCurrency(totalPrincipalPaid + totalInterestPaid + totalFeesPaid)}
        strong
      />
    </SummaryCard>
  )
}

export default LoanLastTransactionCard
